import { CommonEnums } from '../../common.enums';

export class Rlup_Inst {
    rlup_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    lastUpdateBy: string;
    updateBy: string;
    havingClause: string;
    havingClauseValid_Cd: string;
    win_AggregateFlg: string;
    win_Attr_Id: number;
    win_Obj_Id: number;
    win_Length: number;
    win_Length_Metric: string;
    sliding_Interval: number;
    sliding_Interval_Metric: string;
    attr_Tab_Valid_Cd: string;
    lattr_Tab_Valid_Cd: string;
    prop_Tab_Valid_Cd: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.rlup_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.havingClause = CommonEnums.defaults.STRING_EMPTY;
        this.havingClauseValid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.win_AggregateFlg = CommonEnums.defaults.STRING_EMPTY;
        this.win_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.win_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.win_Length = CommonEnums.defaults.LONG_VAL;
        this.win_Length_Metric = CommonEnums.defaults.STRING_EMPTY;
        this.sliding_Interval = CommonEnums.defaults.LONG_VAL;
        this.sliding_Interval_Metric = CommonEnums.defaults.STRING_EMPTY;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.lattr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(rlup_InstTmp: Rlup_Inst): Rlup_Inst {
        let rlup_Inst: Rlup_Inst = new Rlup_Inst();
        rlup_Inst.copyFrom(rlup_InstTmp);
        return rlup_Inst;
    }

    getPrimaryKey(): string {
        return this.rlup_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Rlup_Inst {
        let rlup_InstTmp: Rlup_Inst = new Rlup_Inst();

        rlup_InstTmp.rlup_Inst_Id = this.rlup_Inst_Id;
        rlup_InstTmp.dxMp_Id = this.dxMp_Id;
        rlup_InstTmp.nm = this.nm;
        rlup_InstTmp.description = this.description;
        rlup_InstTmp.ver = this.ver;
        rlup_InstTmp.valid_Cd = this.valid_Cd;
        rlup_InstTmp.persistFlg = this.persistFlg;
        rlup_InstTmp.updateDt = this.updateDt;
        rlup_InstTmp.lastUpdateBy = this.lastUpdateBy;
        rlup_InstTmp.updateBy = this.updateBy;
        rlup_InstTmp.havingClause = this.havingClause;
        rlup_InstTmp.havingClauseValid_Cd = this.havingClauseValid_Cd;
        rlup_InstTmp.win_AggregateFlg = this.win_AggregateFlg;
        rlup_InstTmp.win_Attr_Id = this.win_Attr_Id;
        rlup_InstTmp.win_Obj_Id = this.win_Obj_Id;
        rlup_InstTmp.win_Length = this.win_Length;
        rlup_InstTmp.win_Length_Metric = this.win_Length_Metric;
        rlup_InstTmp.sliding_Interval = this.sliding_Interval;
        rlup_InstTmp.sliding_Interval_Metric = this.sliding_Interval_Metric;
        rlup_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        rlup_InstTmp.lattr_Tab_Valid_Cd = this.lattr_Tab_Valid_Cd;
        rlup_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;

        return rlup_InstTmp;
    }
    
    copyFrom(rlup_InstTmp: Rlup_Inst): void {
        this.rlup_Inst_Id = rlup_InstTmp.rlup_Inst_Id;
        this.dxMp_Id = rlup_InstTmp.dxMp_Id;
        this.nm = rlup_InstTmp.nm;
        this.description = rlup_InstTmp.description;
        this.ver = rlup_InstTmp.ver;
        this.valid_Cd = rlup_InstTmp.valid_Cd;
        this.persistFlg = rlup_InstTmp.persistFlg;
        this.updateDt = rlup_InstTmp.updateDt;
        this.lastUpdateBy = rlup_InstTmp.lastUpdateBy;
        this.updateBy = rlup_InstTmp.updateBy;
        this.havingClause = rlup_InstTmp.havingClause;
        this.havingClauseValid_Cd = rlup_InstTmp.havingClauseValid_Cd;
        this.win_AggregateFlg = rlup_InstTmp.win_AggregateFlg;
        this.win_Attr_Id = rlup_InstTmp.win_Attr_Id;
        this.win_Obj_Id = rlup_InstTmp.win_Obj_Id;
        this.win_Length = rlup_InstTmp.win_Length;
        this.win_Length_Metric = rlup_InstTmp.win_Length_Metric;
        this.sliding_Interval = rlup_InstTmp.sliding_Interval;
        this.sliding_Interval_Metric = rlup_InstTmp.sliding_Interval_Metric;
        this.attr_Tab_Valid_Cd = rlup_InstTmp.attr_Tab_Valid_Cd;
        this.lattr_Tab_Valid_Cd = rlup_InstTmp.lattr_Tab_Valid_Cd;
        this.prop_Tab_Valid_Cd = rlup_InstTmp.prop_Tab_Valid_Cd;
    }

    compare(rlup_InstTmp: Rlup_Inst): string {
        let rlup_InstString: string = this.toString(false);
        let rlup_InstTmpString: string = rlup_InstTmp.toString(false);

        if (rlup_InstString != rlup_InstTmpString) {
            return rlup_InstString + ', ' + rlup_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true) {
       let str:string = "Rlup_Inst [rlup_Inst_Id=" + this.rlup_Inst_Id + ", dxMp_Id=" + this.dxMp_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", updateDt=" + this.updateDt + ", lastUpdateBy=" + this.lastUpdateBy +
            ", updateBy=" + this.updateBy + ", havingClause=" + this.havingClause +
            ", havingClauseValid_Cd=" + this.havingClauseValid_Cd + ", win_AggregateFlg=" + this.win_AggregateFlg +
            ", win_Attr_Id=" + this.win_Attr_Id + ", win_Obj_Id=" + this.win_Obj_Id + ", win_Length=" + this.win_Length +
            ", win_Length_Metric=" + this.win_Length_Metric + ", sliding_Interval=" + this.sliding_Interval +
            ", sliding_Interval_Metric=" + this.sliding_Interval_Metric + ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd +
            ", lattr_Tab_Valid_Cd=" + this.lattr_Tab_Valid_Cd + ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd ;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}